import axios from 'axios';
import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import { ScheduleGroupRequest } from './scheduleGroups.domain';

export const postScheduleGroup = async (
  programId: number,
  request: ScheduleGroupRequest,
): Promise<void> => {
  await axios.post(
    getCreatorApiUrl(`/program/${programId}/schedule-group`),
    request,
    { headers: { Authorization: auth.getToken() } },
  );
};

const responseMessage = (data: unknown) => {
  if (typeof data !== 'object' || data === null || !('message' in data))
    return null;
  const { message } = data;
  if (typeof message === 'string') return message;
  if (Array.isArray(message)) return message.join(', ');
  return null;
};

export const toErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const message = responseMessage(error.response?.data);
    if (message) return message;
  }
  return error instanceof Error ? error.message : 'Something went wrong';
};
